import React, { useState, useEffect } from "react";
import { useAuth } from "../config/AuthContext"; // Use useAuth hook
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import { FaUserCircle } from "react-icons/fa";
import "./NavBar.css"; // Import the CSS file

export default function NavBar() {
  const [menuVisible, setMenuVisible] = useState(false);
  const { user } = useAuth(); // Access the user state from the context

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  useEffect(() => {
    const handleResize = () => {
      const mq = window.matchMedia("(max-width: 1050px)");
      if (!mq.matches) {
        setMenuVisible(false); // Hide menu on resize if not in mobile view
      }
    };

    const mq = window.matchMedia("(max-width: 1050px)");
    mq.addEventListener("change", handleResize);
    handleResize();

    return () => {
      mq.removeEventListener("change", handleResize);
    };
  }, []);

  return (
    <div className="N-body">
      <nav>
        <div className="N-container">
        <div className="N-container2">
        <img
          className="logo"
          src={require("./pictures/logo4.png")}
          alt=""
        />
        <h1>
          <a href="/" className="n-logo">Punjabi Boli</a>
        </h1>          </div>
          <div className="n-menu">
            <a href="/" className="n-diff">Home</a>
            <a href="/courses" className="n-diff">Courses</a>
            <a href="/faq" className="n-diff">FAQ</a>
            <a href="/blog" className="n-diff">Blog</a>
            <a href="/contact" className="n-diff">Contact</a>

            {/* Conditionally render login button or user icon */}
            {user ? (
              <div className="user-icon">
                <Link to="/dashboard"> {/* Add Link to Dashboard */}
                  <FaUserCircle />
                </Link>
              </div>
            ) : (
              <a href="/login" className="n-login is-active">Login</a>
            )}
          </div>
          <div className="ham_container">
          <button
    className={`hamburger ${menuVisible ? "is-active" : ""}`}
    onClick={toggleMenu}
    aria-expanded={menuVisible}
    aria-label="Toggle navigation menu"
>
    <div className="n-back">
        <span></span>
        <span></span>
        <span></span>
    </div>
</button>

          </div>
          <ul className={`ham-nav ${menuVisible ? "menu-visible" : ""}`}>
            <div className="hambackground">
              <li><a href="/" onClick={toggleMenu}>Home</a></li>
              <li><a href="/courses" onClick={toggleMenu}>Courses</a></li>
              <li><a href="/faq" onClick={toggleMenu}>FAQ</a></li>
              <li>
                <a href="/blog" className="n-diff">Blog</a></li>
              <li><a href="/contact" className="n-diff">Contact</a></li>

              {user ? (
                <li><Link to="/dashboard" onClick={toggleMenu}>Profile</Link></li> // Add Link to Dashboard
              ) : (
                <li><a href="/login" onClick={toggleMenu}>Login</a></li>
              )}
            </div>
          </ul>
        </div>
      </nav>
    </div>
  );
}
